import { render, staticRenderFns } from "./CompetitionLogo.vue?vue&type=template&id=90a1cc42&scoped=true"
import script from "./CompetitionLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionLogo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a1cc42",
  null
  
)

export default component.exports